<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-md-12">
        <Loader :loading="httpSend">
          <historico-movimento :historico="historico"></historico-movimento>
        </Loader>
      </div>
    </div>
  </Layout>
</template>

<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import HistoricoMovimento from "@/components/geral/historico-movimento"
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {getHistorico} from "@/api/solicitacao/pessoa";

export default {
  page: {
    title: "Pessoa Física",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loader,
    PageHeader,
    HistoricoMovimento
  },
  data() {
    return {
      title: "Solicitação - Pessoa Física",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Solicitação',
          href: '/contribuinte/solicitacao',
        },
        {
          text: 'Histórico',
          active: true,
        },
      ],
      httpSend: false,
      historico: [],
    };
  },
  created() {
    this.listHistorico()
  },
  methods: {
    listHistorico() {
      this.httpSend = true;
      getHistorico(this.$route.params.ceh_codigo).then(response => {
        if (response.status) {
          this.historico = response.dados;
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
};
</script>


